<script lang="ts">
    import CN from "classnames";
    import { createEventDispatcher } from "svelte";

    import type RadioGroupFieldOptions from "./FormSingleChooseFieldOptions";

    export let options: RadioGroupFieldOptions[];
    export let value: RadioGroupFieldOptions["value"];
    export let name: string;
    const dispatch = createEventDispatcher();

    $: onChange = (event: Event) => {
        if (event.target instanceof HTMLInputElement) {
            const newValue = event.target.value;

            dispatch("change", {
                value: newValue === value ? "" : newValue,
                event,
            });
        }
    };
</script>

<fieldset class="gw-default-reset">
    <div class="gw-choose-size-field" role="radiogroup">
        {#each options as option}
            <label
                class={CN("gw-choose-size-field__label", {
                    "gw-choose-size-field__label--checked":
                        value === option.value,
                })}
            >
                <input
                    {name}
                    type="checkbox"
                    value={option.value}
                    checked={value === option.value}
                    class="gw-choose-size-field__input"
                    on:change={onChange}
                />
                <span class="gw-choose-size-field__text">
                    {option.label}
                </span>
            </label>
        {/each}
    </div>
</fieldset>

<style lang="postcss">
    .gw-choose-size-field {
        display: flex;
        flex-wrap: wrap;
        column-gap: 0.5em;
        row-gap: 0.625em;
        padding-left: 1px;

        &__label {
            display: flex;
            align-items: center;
            padding: 0.5em 1em;
            border: 1px solid #e5e5ec;
            border-radius: 0.5em;
            cursor: pointer;
            background-color: #fff;
            transition: background-color 0.1s ease, box-shadow 0.1s ease;

            &--checked {
                background-color: #e4e7ec;
                border: 1px solid #d0d5dd;
            }

            &:focus-within {
                outline: 1px solid #d0d5dd;
            }
            &:hover {
                background: rgba(242, 244, 247, 0.7);
            }
        }

        &__input {
            position: absolute;
            width: 1px;
            height: 1px;
            overflow: hidden;
            clip: rect(0 0 0 0);
        }

        &__text {
            font-size: 0.75em;
            position: relative;
        }
    }
</style>
